import { Injectable, signal } from '@angular/core';
import { AUTH_TRANSLATIONS } from '../i18n/auth.translations';
import { LANDING_TRANSLATIONS } from '../i18n/landing.translations';
import { COMMON_TRANSLATIONS } from '../i18n/common.translations';
import { Lang, TranslationCatalog } from '../i18n/translations.types';

const TRANSLATIONS: TranslationCatalog = {
  es: {
    ...COMMON_TRANSLATIONS.es,
    ...AUTH_TRANSLATIONS.es,
    ...LANDING_TRANSLATIONS.es,
  },
  en: {
    ...COMMON_TRANSLATIONS.en,
    ...AUTH_TRANSLATIONS.en,
    ...LANDING_TRANSLATIONS.en,
  },
};

@Injectable({ providedIn: 'root' })
export class LanguageService {
  currentLang = signal<Lang>('es');

  constructor() {
    if (typeof window === 'undefined') return;

    const saved = localStorage.getItem('wm-lang');
    if (saved === 'es' || saved === 'en') {
      this.apply(saved);
      return;
    }

    const nav = typeof navigator !== 'undefined' ? navigator.language : '';
    if (nav?.toLowerCase().startsWith('en')) {
      this.apply('en');
      return;
    }

    this.apply('es');
  }

  setLang(lang: Lang) {
    this.apply(lang);
  }

  /**
   * Agrega las traducciones de un módulo (se llama al activar su ruta, vía `provideTranslations`),
   * para que no engorden el bundle inicial.
   */
  register(catalog: TranslationCatalog): void {
    Object.assign(TRANSLATIONS.es, catalog.es);
    Object.assign(TRANSLATIONS.en, catalog.en);
  }

  t(key: string, vars?: Record<string, string | number>) {
    const lang = this.currentLang();
    const fallback = TRANSLATIONS.es[key] ?? key;
    let text = TRANSLATIONS[lang]?.[key] ?? fallback;
    if (vars) {
      Object.entries(vars).forEach(([k, v]) => {
        text = text.replace(`{${k}}`, String(v));
      });
    }
    return text;
  }

  private apply(lang: Lang) {
    this.currentLang.set(lang);
    document.documentElement.lang = lang;
    localStorage.setItem('wm-lang', lang);
  }
}
